import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Segment, Grid, Header } from "semantic-ui-react";
import "../../../scss/index.scss";
import { estiloSegmento } from "../../../estilos/segmentos";
import { apiUsuario } from "../../../api/usuario";
import { apiViaje } from "../../../api/viaje";
import { ENTORNO } from "../../../utils/constantes";
import { setTitulo, getrole, getid } from "../../../utils/variablesLocales";
import HomeIcon from "@mui/icons-material/Home";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import Container from "@mui/material/Container";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import IconoBanco from "@mui/icons-material/AccountBalance";
import IconoTitular from "@mui/icons-material/Person";
import IconoCBU from "@mui/icons-material/Numbers";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import { Player } from "@lottiefiles/react-lottie-player";
import animacion from "../../../imagenes/AnimacionesVarias/Billetera.json";
import animacionBackdrop from "../../../imagenes/AnimacionesVarias/LoadingMap.json";
import logoLocalPoint from "../../../imagenes/logoConNombre.png";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const apiviaje = new apiViaje();
const apiusuario = new apiUsuario();

export function Billetera() {
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  setTitulo("Billetera");

  ////////////////////////////////

  const [SaldoActual, setSaldoActual] = useState(null);
  const [Banco, setBanco] = useState(null);
  const [Titular, setTitular] = useState(null);
  const [CBU, setCBU] = useState(null);

  ////////////////////////////////

  /*este es como el load de asp.net*/
  useEffect(() => {
    (async () => {
      try {
        //controlando la seguridad para que solo acceda a esta pantalla el perfil que corresponda
        if (getrole() !== "Conductor") {
          navigate(ENTORNO.URL_APLICACION + "/CerrarSesion");
        }

        //calcular saldo de chofer
        apiviaje.calcularSaldoConductor(getid());

        //obtener dinero en cuenta, cuenta bancaria vinculada
        const respuesta = await apiusuario.obtener(getid());
        setSaldoActual(
          Intl.NumberFormat("es-CL").format(respuesta[0].SaldoEnCuenta)
        );
        setBanco(respuesta[0].Banco_Nombre);
        setTitular(respuesta[0].Banco_Titular);
        setCBU(respuesta[0].Banco_CBU);
      } catch (error) {
        console.error(error);
      }
    })();
  });

  ////////////////////////////////

  const navigate = useNavigate();

  const navigateToInicio = () => {
    navigate(ENTORNO.URL_APLICACION + "/Conductor/Inicio");
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div style={{ overfxlow: "hidden", touchAction: "none" }}>
      <div className="divPrincipal_ImportarNomina">
        <AppBar style={{ background: "#DC030E" }}>
          <Toolbar>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              onClick={navigateToInicio}
              aria-label="menu"
              sx={{ mr: 2 }}
            >
              <HomeIcon />
            </IconButton>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Billetera
            </Typography>
            <img
              src={logoLocalPoint}
              style={{ marginTop: "1px" }}
              width="75"
              alt="Logo"
            />
          </Toolbar>
        </AppBar>
        <Container>
          <Box sx={{ my: 2 }}>
            <Segment style={estiloSegmento.Administrador}>
              <Grid
                textalign="center"
                container
                style={{
                  padding: "5em 0em",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div className="ingresar">
                  <Grid.Row style={{ width: "100%" }}>
                    <Grid.Column style={{ width: "100%" }}>
                      <Box
                        //component="form"
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          "& > :not(style)": { m: 1, width: "100%" },
                        }}
                        noValidate
                        autoComplete="off"
                      >
                        <Card variant="outlined" sx={{ maxWidth: 360 }}>
                          <Box sx={{ p: 2 }}>
                            <Stack
                              direction="row"
                              justifyContent="space-between"
                              alignItems="center"
                            >
                              <Typography
                                gutterBottom
                                variant="h5"
                                component="div"
                              >
                                Saldo actual
                              </Typography>
                              <Typography
                                gutterBottom
                                variant="h5"
                                component="div"
                              >
                                ${SaldoActual}
                              </Typography>
                            </Stack>
                            <Typography color="text.secondary" variant="body2">
                              Importe pendiente de debitar por Local Point al
                              conductor
                            </Typography>
                          </Box>
                          <Divider />
                          <Box sx={{ p: 2 }}>
                            <Header as="h3">Cuenta bancaria vinculada</Header>
                            <List
                              sx={{
                                bgcolor: "background.paper",
                              }}
                            >
                              <ListItem>
                                <ListItemAvatar>
                                  <Avatar>
                                    <IconoBanco />
                                  </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                  primary="Banco"
                                  secondary={Banco}
                                />
                              </ListItem>
                              <ListItem>
                                <ListItemAvatar>
                                  <Avatar>
                                    <IconoTitular />
                                  </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                  primary="Titular"
                                  secondary={Titular}
                                />
                              </ListItem>
                              <ListItem>
                                <ListItemAvatar>
                                  <Avatar>
                                    <IconoCBU />
                                  </Avatar>
                                </ListItemAvatar>
                                <ListItemText primary="CBU" secondary={CBU} />
                              </ListItem>
                            </List>
                          </Box>
                        </Card>
                        <Player
                          src={animacion}
                          className="player"
                          loop
                          autoplay
                          style={{ height: 110 }}
                        />
                      </Box>
                    </Grid.Column>
                  </Grid.Row>
                </div>
              </Grid>
            </Segment>
          </Box>
        </Container>
      </div>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        onClick={handleClose}
      >
        <Player
          src={animacionBackdrop}
          className="player"
          loop
          autoplay
          style={{ height: 110 }}
        />
      </Backdrop>
    </div>
  );
}
